import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Select from "react-select";
// import { DatePicker } from "antd";
import { useQuery } from "@tanstack/react-query";
// import { getPack } from "../../connections/getPack";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

// import dayjs from "dayjs";
import { updateMedicineSalts } from "../../connections/updateMedicineSalts";
import useDebounce from "../../utils/hooks";
import { getAllMedicine } from "../../connections/getAllMedicine";
import CreatableSelect from "react-select/creatable";
import { getAllFormType } from "../../connections/getAllFormType";
import { CloseIcon } from "yet-another-react-lightbox";


const UpdateMedicineSalts = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const navigate = useNavigate();
  const [medDetails, setMedDetails] = useState({});
  const [medicineInput, setMedicineInput] = useState("");
  const [medicinesAttributes, setMedicinesAttributes] = useState([]);
  // Only medicines the user explicitly removed with the delete button.
  // Nothing else may ever be sent with _destroy.
  const [removedMedicines, setRemovedMedicines] = useState([]);

  // const [batches, setBatches] = useState([]);
  // const [formType, setFormType] = useState([]);
  // const [pack, setPack] = useState([]);
  // const [inputValue, setInputValue] = useState("");

  // const { data: getPackData } = useQuery({
  //   queryKey: ["getPack"],
  //   queryFn: () => getPack(user?.token),
  //
  //   refetchOnWindowFocus: false, // Don't refetch when window regains focus
  //   refetchOnReconnect: false, // Don't refetch when reconnecting
  // });
  const location = useLocation();
  const medSaltData = location.state || null;
  const handleChangeMed = (field, val) => {
    setMedDetails((prev) => ({
      ...prev,
      [field]: val,
    }));
  };
  // const handleChangeMed = (field, val) => {
  //   setMedDetails((prev) => ({
  //     ...prev,
  //     [field]: val,
  //   }));
  // };
  // medicine Options
  const debouncedInputMedicine = useDebounce(medicineInput, 1000);
  const { data: getAllMedicineData } = useQuery({
    queryKey: ["getAllMedicine", debouncedInputMedicine],
    queryFn: () =>
      getAllMedicine(user?.token, "q", 1, 10, debouncedInputMedicine),
    enabled: !!debouncedInputMedicine,
    cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });


  const handleChangeMedicine = (index, field, value) => {
    const newMedicines = [...medicinesAttributes];
    newMedicines[index] = { ...newMedicines[index], [field]: value };
    setMedicinesAttributes(newMedicines);
  };

  const { data: getAllFormTypeData } = useQuery({
    queryKey: ["getAllFormType"],
    queryFn: () => getAllFormType(user?.token),
    enabled: !!user?.token,
    cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const dataForm = getAllFormTypeData || [];
  const formattedFormType = dataForm?.map((el) => ({
    value: el?.value,
    label: el?.label,
  }));
  const allMedicine = getAllMedicineData?.payload?.medicines || [];

  // ✅ Create formatted options from API
  const apiOptions = allMedicine.map((el) => ({
    value: el?.id,
    label: el?.name,
  }));

  // ✅ Add existing (medSaltData.medicines) also in options
  const existingOptions =
    medSaltData?.medicines?.map((item) => ({
      value: item?.id,
      label: item?.name,
    })) || [];

  // ✅ Merge both and remove duplicates by `value`
  const formattedMedicineOptions = [
    ...existingOptions,
    ...apiOptions.filter(
      (opt) => !existingOptions.some((ex) => ex.value === opt.value)
    ),
  ];


  const handleMedicineChange = (value) => {
    setMedicineInput(value);
  };



  const handleAddMedicine = (e) => {
    e.preventDefault();
    setMedicinesAttributes((prev) => [
      ...prev,
      {
        medicine_id: "",
        medicine_name: "",
        flat_price: "",
        form_type: "",
      },
    ]);
  };
  // const handleChangeBatch = (index, field, value) => {
  //   const newMedBatch = [...batches];
  //   newMedBatch[index] = { ...newMedBatch[index], [field]: value };
  //   setBatches(newMedBatch);
  // };
  // const handleSearchMedSalt = (inputValue) => {
  //   const query = inputValue?.toLowerCase();
  //   const storeSuppliers = JSON.parse(localStorage.getItem("allMedSalt")) || [];

  //   const filteredList = storeSuppliers.filter((el) =>
  //     el?.name?.toLowerCase().startsWith(query || "")
  //   );

  //   const limitedResults = (query ? filteredList : storeSuppliers)
  //     .slice(0, 10)
  //     .map((el) => ({
  //       value: el?.id,
  //       label: el?.name,
  //     }));

  //   setAllMedSalt(limitedResults);
  // };

  // const formTypeOptions = formType.map((item) => ({
  //   value: item.value,
  //   label: item.value,
  // }));
  // const options = pack?.map((item) => ({
  //   value: item.value,
  //   label: item.value,
  // }));
  // const debouncedInput = useDebounce(inputValue, 700);
  // const handleInputChange = (inputValue) => {
  //   setInputValue(inputValue);
  // };
  // const handleAddRow = (e) => {
  //   e.preventDefault();
  //   setBatches((prev) => [
  //     ...prev,
  //     {
  //       name: "",
  //       discount: 0,
  //       batch: "",
  //       company: "",
  //       amount: 0,
  //       purchase_cost: "",
  //       form_type: "",
  //       packing: "",
  //       stock_left: "",
  //       gst: "",
  //       units_purchased: 0,
  //       auto_purchase_threshold: 0,
  //       expiry_date: "",
  //       manufacture_date: "",
  //       delivered_at: "",
  //       order_at: "",
  //     },
  //   ]);
  // };
  // const handleRemoveRow = (e, idx) => {
  //   e.preventDefault();

  //   const newRow = [...batches];
  //   const updatedRow = newRow?.filter((_, index) => index !== idx);
  //   setBatches(updatedRow);
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!medDetails.name) {
      toast.error("Name is required");
      return;
    }

    // Filter valid medicines
    const validMedicines = medicinesAttributes
      .filter((med) => med?.medicine_id || med?.medicine_name) // only entries with medicine_id and name
      .map((med) => {
        // Ensure form_type is selected
        if (!med?.form_type) {
          toast.error(`Please select form type for medicine "${med?.medicine_name}"`);
          throw new Error("Form type missing"); // Stop submission
        }
        return {
          ...(med.medicine_id ? { id: med.medicine_id } : {}),
          name: med?.medicine_name,
          form_type: med?.form_type,
          flat_price: med?.flat_price || "",
        };
      });


    // Only rows the user explicitly removed are destroyed. This must never be
    // derived by diffing against the loaded list - changing a row's selection,
    // or losing an id, would then silently destroy the previous medicine.
    const stillListed = new Set(
      medicinesAttributes.map((med) => med?.medicine_id).filter(Boolean)
    );
    const deletedMedicines = removedMedicines
      .filter((oldMed) => oldMed?.id && !stillListed.has(oldMed.id))
      .map((oldMed) => ({
        id: oldMed.id,
        name: oldMed?.name,
        form_type: oldMed?.form_type,
        flat_price: oldMed?.flat_price || "",
        _destroy: 1,
      }));

    if (deletedMedicines.length) {
      const names = deletedMedicines.map((med) => med.name).join(", ");
      const confirmed = window.confirm(
        `These medicines will be removed from "${medDetails?.name}": ${names}.\n\nContinue?`
      );
      if (!confirmed) return;
    }

    // ✅ Merge valid + deleted
    const finalMedicines = [...validMedicines, ...deletedMedicines];

    const payload = {
      medicine_salt: {
        ...medDetails,
        medicines_attributes: finalMedicines,
      },

    };

    try {
      const result = await updateMedicineSalts(
        user?.token,
        payload,
        medSaltData?.id
      );
      if (result?.status?.status === "SUCCESS") {
        toast.success("Medicine Salts Updated Successfully");
        navigate(-1);
        // setBatches([]);
        // setMedDetails({});
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (medSaltData) {
      // console.log(medSaltData);
      setMedDetails({ name: medSaltData?.name });
      // console.log(medSaltData?.medicines, 'medSaltData?.medicines_attributes')
      setMedicinesAttributes(medSaltData?.medicines?.map((item) => ({
        medicine_id: item.id,
        medicine_name: item?.name,
        form_type: item?.form_type,
        flat_price: item?.flat_price || "",
      })) || []);
    }

  }, [medSaltData]);
  // console.log(medIds);
  // useEffect(() => {
  //   if (debouncedInput) {
  //     const optionExists = pack.some((item) => item.value === debouncedInput);

  //     if (!optionExists) {
  //       const newOption = {
  //         value: debouncedInput,
  //         label: debouncedInput,
  //       };
  //       setPack((prevPack) => [...prevPack, newOption]);
  //     }
  //   }
  // }, [debouncedInput, pack]);

  // console.log(medicinesAttributes, 'medicines_attributes');
  // console.log(medDetails, 'medDetails')

  const handleRemoveMedicine = (e, idx) => {
    e.preventDefault();

    const row = medicinesAttributes[idx];
    const existing = medSaltData?.medicines?.find(
      (med) => med?.id === row?.medicine_id
    );

    // An already saved medicine is only marked for removal when the user asks
    // for it here, and only after confirming
    if (existing) {
      const confirmed = window.confirm(
        `Remove "${existing?.name}" from this salt?`
      );
      if (!confirmed) return;
      setRemovedMedicines((prev) =>
        prev.some((med) => med?.id === existing?.id) ? prev : [...prev, existing]
      );
    }

    setMedicinesAttributes((prev) =>
      prev?.filter((_, index) => index !== idx)
    );
  };
  return (
    <div>
      <Header />
      <Sidebar activeClassName="medicine-salt-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}> Medicine Salts</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      Update Medicine Salts
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Medicine Salts</h4>
                          </div>
                        </div>
                        <div className="col-12 col-md-12 col-xl-12">
                          <div className="form-group local-forms">
                            <label>
                              Name
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              value={medDetails?.name}
                              onChange={(e) =>
                                handleChangeMed("name", e?.target?.value)
                              }
                              className="form-control"
                              type="text"
                              required={true}
                            />
                          </div>
                        </div>



                        {medicinesAttributes?.length > 0 &&
                          medicinesAttributes?.map((el, index) => (
                            <React.Fragment key={index}>
                              <div className="col-6 col-md-4 col-lg-4">
                                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                                  <div style={{ marginRight: "8px", marginBottom: '4px' }}>
                                    <p> {index + 1}</p>
                                  </div>
                                  <div className="form-group local-forms" style={{ flex: 1, width: "100%" }}>
                                    <label>
                                      Medicine
                                      <span className="login-danger">*</span>
                                    </label>
                                    <CreatableSelect
                                      options={[
                                        ...(formattedMedicineOptions || []),
                                        ...(medSaltData?.medicines?.map((item) => ({
                                          value: item.id,
                                          label: item?.name,
                                        })) || []),
                                      ]}
                                      onInputChange={handleMedicineChange}
                                      value={
                                        el?.medicine_id
                                          ? { value: el.medicine_id, label: el.medicine_name }
                                          : el?.medicine_name
                                            ? { value: el.medicine_name, label: el.medicine_name }
                                            : null
                                      }
                                      onChange={(selectedOption, actionMeta) => {
                                        // check if it's a new option
                                        const isNew = actionMeta.action === "create-option";
                                        if (isNew) {
                                          // Clearing the id of a saved row would
                                          // orphan that medicine on submit
                                          if (medicinesAttributes[index]?.medicine_id) {
                                            toast.error(
                                              "This row is already linked to a saved medicine. Remove the row first, then add the new medicine."
                                            );
                                            return;
                                          }
                                          // only fill medicine name + value
                                          const updatedFields = {
                                            medicine_id: null, // ya backend generate karega
                                            medicine_name: selectedOption?.label,

                                          };

                                          const newMedicines = [...medicinesAttributes];
                                          newMedicines[index] = { ...newMedicines[index], ...updatedFields };
                                          setMedicinesAttributes(newMedicines);
                                        } else {
                                          // ✅ duplicate check
                                          if (
                                            medicinesAttributes?.some(
                                              (medi) => medi?.medicine_id === selectedOption?.value
                                            )
                                          ) {
                                            toast.info("Selected Medicine already in the list");
                                            return;
                                          }
                                          // existing medicine selected
                                          const selectedMedicine = getAllMedicineData?.payload?.medicines?.find(
                                            (m) => m?.id === selectedOption?.value
                                          );
                                          const updatedFields = {
                                            medicine_id: selectedOption?.value,
                                            medicine_name: selectedOption?.label,
                                            form_type: selectedMedicine?.form_type || "",
                                            flat_price: selectedMedicine?.flat_price || "",
                                          };

                                          const newMedicines = [...medicinesAttributes];
                                          newMedicines[index] = { ...newMedicines[index], ...updatedFields };
                                          setMedicinesAttributes(newMedicines);
                                        }
                                      }}
                                      styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 999999,
                                        }),
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          borderColor: state.isFocused
                                            ? "#007A99"
                                            : "rgba(46, 55, 164, 0.1)",
                                          boxShadow: state.isFocused
                                            ? "0 0 0 1px #007A99"
                                            : "none",
                                          "&:hover": {
                                            borderColor: "rgba(46, 55, 164, 0.1)",
                                          },
                                          borderRadius: "10px",
                                          fontSize: "14px",
                                          minHeight: "45px",
                                        }),
                                        dropdownIndicator: (base, state) => ({
                                          ...base,
                                          transform: state.selectProps.menuIsOpen
                                            ? "rotate(-180deg)"
                                            : "rotate(0)",
                                          transition: "250ms",
                                          width: "35px",
                                          height: "35px",
                                        }),
                                        option: (provided) => ({
                                          ...provided,
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "100%",
                                          fontSize: "14px",
                                        }),
                                      }}
                                      // isMulti
                                      isSearchable
                                      placeholder="Choose medicine"
                                      className="react-select"
                                      classNamePrefix="select"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-6 col-md-4 col-lg-4">
                                <div className="form-group local-forms">
                                  <label>
                                    Medicine Form Type
                                    <span className="login-danger">*</span>
                                  </label>
                                  <Select

                                    options={formattedFormType || []}
                                    value={formattedFormType?.find(
                                      (opt) => opt.value === el?.form_type  // el = current row ka medicine object
                                    )} onChange={(selectedOptions) => {
                                      handleChangeMedicine(
                                        index,
                                        "form_type",
                                        selectedOptions?.value
                                      ); // Pass the array of values to handleChangeMedicine
                                    }}
                                    styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 999999,
                                      }),
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused
                                          ? "#007A99"
                                          : "rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: "rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                      }),
                                      option: (provided) => ({
                                        ...provided,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "100%",
                                        fontSize: "14px",
                                      }),
                                    }}
                                    // isMulti
                                    isSearchable
                                    placeholder="Choose Form Type"
                                    className="react-select"
                                    classNamePrefix="select"
                                  // components={{ MenuList }}
                                  />
                                </div>
                              </div>
                              <div className="col-6 col-md-3 col-lg-3">
                                <div className="form-group local-forms">
                                  <label>
                                    Medicine Flat Price
                                  </label>
                                  {/* <TextField sx={{ width: '100%' }} /> */}
                                  <input
                                    value={el?.flat_price}
                                    onChange={(e) =>
                                      handleChangeMedicine(index, "flat_price", e?.target?.value)
                                    }
                                    className="form-control"
                                    type="text"
                                    required={true}
                                  />
                                </div>
                              </div>
                              <div className="col-6 col-md-1 col-lg-1">
                                <button
                                  style={{
                                    maxWidth: "150px", height: "45px", display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onClick={(e) =>
                                    handleRemoveMedicine(e, index)
                                  }
                                  className="btn btn-primary submit-form form-control mb-4"
                                >
                                  <CloseIcon />
                                </button>
                              </div>
                            </React.Fragment>
                          ))}


                        <div className="col-12 col-md-12 col-xl-12">
                          <button
                            style={{ width: 300 }}
                            className="btn btn-primary submit-form me-2 form-control"
                            onClick={handleAddMedicine}
                          >
                            Add  Medicine
                          </button>
                        </div>

                        {/* {part two} */}
                        {/* <div className="col-12">
                          <div className="form-heading">
                            <button
                              className="btn btn-primary cancel-form mb-4"
                              disabled
                            >
                              Brands
                            </button>
                          </div>
                        </div> */}
                        {/* {batches?.length > 0 &&
                          batches?.map((el, index) => (
                            <React.Fragment key={index}>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Name</label>
                                  <input
                                    value={el?.name}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "name",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Company</label>
                                  <input
                                    value={el?.company}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "company",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                  />
                                </div>
                              </div>

                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Form Type </label>
                                  <Select
                                    value={
                                      formTypeOptions?.find(
                                        (option) =>
                                          option.value === el?.form_type
                                      ) || null
                                    }
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "form_type",
                                        e?.value
                                      )
                                    }
                                    options={formTypeOptions}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    id="search-commodity"
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Discount</label>
                                  <input
                                    value={el?.discount}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "discount",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="number"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Batch</label>
                                  <input
                                    value={el?.batch}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "batch",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms cal-icon">
                                  <label>Manufacture date</label>
                                  <DatePicker
                                    value={
                                      el?.manufacture_date
                                        ? dayjs(el?.manufacture_date)
                                        : null
                                    }
                                    className="form-control datetimepicker"
                                    onChange={(_, dateString) =>
                                      handleChangeBatch(
                                        index,
                                        "manufacture_date",
                                        dateString
                                      )
                                    }
                                    suffixIcon={null}
                                    style={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor:
                                          "2px solid rgba(46, 55, 164, 0.1)",
                                        "&:hover": {
                                          borderColor: state.isFocused
                                            ? "none"
                                            : "none",
                                        },
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms cal-icon">
                                  <label>Expiry date</label>
                                  <DatePicker
                                    value={
                                      el?.expiry_date
                                        ? dayjs(el?.expiry_date)
                                        : null
                                    }
                                    className="form-control datetimepicker"
                                    onChange={(_, dateString) =>
                                      handleChangeBatch(
                                        index,
                                        "expiry_date",
                                        dateString
                                      )
                                    }
                                    suffixIcon={null}
                                    style={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor:
                                          "2px solid rgba(46, 55, 164, 0.1)",
                                        "&:hover": {
                                          borderColor: state.isFocused
                                            ? "none"
                                            : "none",
                                        },
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Amount</label>
                                  <input
                                    value={el?.amount}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "amount",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="number"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Purchase cost</label>
                                  <input
                                    value={el?.purchase_cost}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "purchase_cost",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="number"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Packing</label>
                                  <Select
                                    value={
                                      pack.find(
                                        (option) => option.value === el?.packing
                                      ) || null
                                    }
                                    onChange={(e) => {
                                      handleChangeBatch(
                                        index,
                                        "packing",
                                        e?.value // Access the value directly from the selected option
                                      );
                                    }}
                                    onInputChange={handleInputChange}
                                    options={pack}
                                    placeholder="select pack"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused
                                          ? "#007A99"
                                          : "rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: "rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                      }),
                                    }}
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>Stock left</label>
                                  <input
                                    value={el?.stock_left}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "stock_left",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="number"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms cal-icon">
                                  <label>Order At</label>
                                  <DatePicker
                                    value={
                                      el?.purchased_at
                                        ? dayjs(el?.purchased_at)
                                        : null
                                    }
                                    className="form-control datetimepicker"
                                    onChange={(_, dateString) =>
                                      handleChangeBatch(
                                        index,
                                        "purchased_at",
                                        dateString
                                      )
                                    }
                                    suffixIcon={null}
                                    style={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor:
                                          "2px solid rgba(46, 55, 164, 0.1)",
                                        "&:hover": {
                                          borderColor: state.isFocused
                                            ? "none"
                                            : "none",
                                        },
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms cal-icon">
                                  <label>Delivered At</label>
                                  <DatePicker
                                    value={
                                      el?.delivered_at
                                        ? dayjs(el?.delivered_at)
                                        : null
                                    }
                                    className="form-control datetimepicker"
                                    onChange={(_, dateString) =>
                                      handleChangeBatch(
                                        index,
                                        "delivered_at",
                                        dateString
                                      )
                                    }
                                    suffixIcon={null}
                                    style={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor:
                                          "2px solid rgba(46, 55, 164, 0.1)",
                                        "&:hover": {
                                          borderColor: state.isFocused
                                            ? "none"
                                            : "none",
                                        },
                                      }),
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>GST</label>
                                  <input
                                    value={el?.gst}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "gst",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                  />
                                </div>
                              </div>
                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Units purchased
                                  </label>
                                  <input
                                    value={el?.units_purchased}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "units_purchased",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="number"
                                  />
                                </div>
                              </div>

                              <div className="col-12 col-md-4 col-xl-2">
                                <div className="form-group local-forms">
                                  <label>
                                    Auto Purchase
                                  </label>
                                  <input
                                    value={el?.auto_purchase_threshold}
                                    onChange={(e) =>
                                      handleChangeBatch(
                                        index,
                                        "auto_purchase_threshold",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="number"
                                  />
                                </div>
                              </div>

                              <div
                                style={{ marginBottom: "20px" }}
                                className="col-12 col-md-6 col-xl-6"
                              >
                                <button
                                  style={{
                                    maxWidth: "200px",
                                  }}
                                  onClick={(e) => handleRemoveRow(e, index)}
                                  className="btn btn-primary submit-form me-2 form-control"
                                >
                                  Remove
                                </button>
                              </div>
                            </React.Fragment>
                          ))} */}
                        {/* <div
                          style={{ display: "inline-block" }}
                          className="col-12 col-md-6 col-xl-5"
                        >
                          <button
                            style={{
                              display: "block !important",
                              maxWidth: "200px",
                            }}
                            className="btn btn-primary submit-form me-2 form-control mb-4"
                            onClick={handleAddRow}
                          >
                            Add New Item
                          </button>
                        </div> */}
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleSubmit}
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(-1);
                              }}
                              type="submit"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default UpdateMedicineSalts;
